module.exports = __webpack_public_path__ + "media/app/assets/images/phone-mount-large-15b6469ac9f1a9e1d4c204420b564e4e.jpg";